import {
  ButtonTracking,
  ScreenTracking,
  SCREEN_ASSET_ID
} from '../../domain/amplitude'

export const ScreenOpendedEvent: ScreenTracking = {
  asset_id: SCREEN_ASSET_ID,
  heading: 'Password Recovery',
  screen: 'forgot',
  from_screen: 'login'
}

export const RecoveryButtonEvent: ButtonTracking = {
  asset_id: 'nextButton',
  asset_text: 'SEND',
  screen: 'forgot'
}

export const TroubleButtonEvent: ButtonTracking = {
  asset_id: 'nextButton',
  asset_text: 'Having trouble getting in ?',
  screen: 'forgot'
}
